import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "components/form/Select/SimpleSelect";

interface ShouldBeMonitoredSelectProps {
    value: string | null | undefined;
    onChange(newValue: string | null): void;
}

const items: SimpleSelectItem[] = [
    {value: "", text: ""},
    {value: "true", text: "Yes"},
    {value: "false", text: "No"},
];

const ShouldBeMonitoredSelect: React.FC<ShouldBeMonitoredSelectProps> = props => (
    <SimpleSelect
        label="Should Be Monitored"
        value={props.value === null || props.value === undefined ? "" : props.value}
        onChange={v => props.onChange(v === "" ? null : v)}
        items={items}
    />
);

export default ShouldBeMonitoredSelect;
